// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__6LzHN","myModalContent":"MyModal_myModalContent__4ipr-","active":"MyModal_active__OoNNR"};